import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faBars,
  faBell,
  faBold,
  faBuilding,
  faCalendarAlt,
  faCaretDown,
  faCaretUp,
  faCheck,
  faCircle,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faCode,
  faCog,
  faCoins,
  faComment,
  faComments,
  faCopy,
  faCreditCard,
  faEnvelope,
  faExclamationCircle,
  faEye,
  faFilePdf,
  faFilter,
  faHeading,
  faIdCard,
  faInfo,
  faInfoCircle,
  faItalic,
  faKey,
  faList,
  faListOl,
  faListUl,
  faMinus,
  faPaperPlane,
  faPencilAlt,
  faPercent,
  faPortrait,
  faPoundSign,
  faPlus,
  faProjectDiagram,
  faRedo,
  faSearch,
  faSpinner,
  faStrikethrough,
  faSyncAlt,
  faTachometerAlt,
  faThLarge,
  faTimes,
  faTrash,
  faUnderline,
  faUndo,
  faUser,
  faUserCog,
  faUsers
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faBars,
  faBell,
  faBold,
  faBuilding,
  faCalendarAlt,
  faCaretDown,
  faCaretUp,
  faCheck,
  faCircle,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faCode,
  faCog,
  faCoins,
  faComment,
  faComments,
  faCopy,
  faCreditCard,
  faEnvelope,
  faExclamationCircle,
  faEye,
  faFilter,
  faFilePdf,
  faHeading,
  faIdCard,
  faInfo,
  faInfoCircle,
  faItalic,
  faKey,
  faList,
  faListOl,
  faListUl,
  faMinus,
  faPaperPlane,
  faPencilAlt,
  faPercent,
  faPortrait,
  faPoundSign,
  faPlus,
  faProjectDiagram,
  faRedo,
  faSearch,
  faSpinner,
  faStrikethrough,
  faSyncAlt,
  faTachometerAlt,
  faThLarge,
  faTimes,
  faTrash,
  faUndo,
  faUnderline,
  faUser,
  faUserCog,
  faUsers
)
